import { useQuery } from '@tanstack/react-query';
import { CompaniesService, TCCompany as Company } from 'src/api/generated';
import { ApiResponse } from 'src/hooks/api/api';

const STALE_TIME_IN_MS = 5 * 60 * 1000;

/**
 * Options for useCompanies hook
 */
interface UseCompaniesOptions {
  /** Whether the query should be enabled. Defaults to true */
  enabled?: boolean;
}

/**
 * Response from useCompanies hook
 */
interface UseCompaniesResponse extends ApiResponse {
  companies: Company[];
}

/**
 * Hook to fetch all companies
 * @param options - Configuration options for the query
 * @returns Companies data and query state
 */
export const useCompanies = (
  options: UseCompaniesOptions = {}
): UseCompaniesResponse => {
  const { enabled = true } = options;

  const fetchCompanies = async (): Promise<Company[]> => {
    return await CompaniesService.listCompanies();
  };

  const {
    data,
    error,
    isLoading: loading,
    refetch,
  } = useQuery({
    queryKey: ['companies'],
    queryFn: fetchCompanies,
    staleTime: STALE_TIME_IN_MS,
    enabled,
  });

  return {
    loading,
    error,
    companies: data ?? [],
    refetch,
  };
};
